import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-681a34d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "carousel-indicators"
}
const _hoisted_3 = ["data-bs-target", "data-bs-slide-to", "aria-current", "aria-label"]
const _hoisted_4 = { class: "carousel-inner" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "btn btn-primary-residential px-3 px-lg-4 py-1 py-lg-2" }
const _hoisted_12 = ["data-bs-target"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "carousel-control-prev-icon",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Previous", -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = ["data-bs-target"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "carousel-control-next-icon",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Next", -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.uniqueId,
    class: "carousel-banner carousel slide",
    "data-bs-ride": "carousel"
  }, [
    (_ctx.images.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, index) => {
            return (_openBlock(), _createElementBlock("button", {
              key: `inidcator-${_ctx.uniqueId}-${index}`,
              type: "button",
              "data-bs-target": `#${_ctx.uniqueId}`,
              "data-bs-slide-to": index,
              class: _normalizeClass({'active': index == 0}),
              "aria-current": index == 0 ? true : false,
              "aria-label": `Slide ${index + 1}`
            }, null, 10, _hoisted_3))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `image-${_ctx.uniqueId}-${index}`,
          class: _normalizeClass(["carousel-item position-relative", {'active': index == 0}])
        }, [
          (image.slot)
            ? _renderSlot(_ctx.$slots, "default", { key: 0 }, () => [
                _createElementVNode("div", {
                  innerHTML: image.slot
                }, null, 8, _hoisted_5)
              ], true)
            : (image.src && !image.buttonText)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (image.linkTo)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: image.linkTo,
                        class: "text-decoration-none"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: `${require('@/assets/' + image.src.replace(/^\//g, ''))}`,
                            class: "d-block w-100",
                            alt: image.alt || ''
                          }, null, 8, _hoisted_6)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: `${require('@/assets/' + image.src.replace(/^\//g, ''))}`,
                        class: "d-block w-100",
                        alt: image.alt || ''
                      }, null, 8, _hoisted_7))
                ], 64))
              : (image.src)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("img", {
                      src: `${require('@/assets/' + image.src.replace(/^\//g, ''))}`,
                      class: "d-block w-100",
                      alt: image.alt || ''
                    }, null, 8, _hoisted_8),
                    _createElementVNode("div", {
                      class: _normalizeClass(["position-absolute", `carousel-heading ${image.headingClass}`])
                    }, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(index == 0 ? 'h1' : 'h2'), { class: "text-uppercase mb-2 mb-lg-4 h1 fw-bold" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            innerHTML: image.heading
                          }, null, 8, _hoisted_9)
                        ]),
                        _: 2
                      }, 1024)),
                      _createElementVNode("div", {
                        class: "banner-copy h4",
                        innerHTML: image.copy
                      }, null, 8, _hoisted_10),
                      (image.linkTo)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: image.linkTo || '/',
                            class: "text-decoration-none"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("button", _hoisted_11, _toDisplayString(image.buttonText), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : _createCommentVNode("", true)
                    ], 2)
                  ], 64))
                : _createCommentVNode("", true)
        ], 2))
      }), 128))
    ]),
    (_ctx.images.length > 1)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("button", {
            class: "carousel-control-prev",
            type: "button",
            "data-bs-target": `#${_ctx.uniqueId}`,
            "data-bs-slide": "prev"
          }, _hoisted_15, 8, _hoisted_12),
          _createElementVNode("button", {
            class: "carousel-control-next",
            type: "button",
            "data-bs-target": `#${_ctx.uniqueId}`,
            "data-bs-slide": "next"
          }, _hoisted_19, 8, _hoisted_16)
        ], 64))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}